/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getContractsList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CONTRACTS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getContractById: (id) => {
    const url = `${API_ENDPOINTS.GET_CONTRACTS}/${id}`;
    return axios.get(url, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  createContract: (data) => {
    return axios.post(API_ENDPOINTS.GET_CONTRACTS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
